export enum Breakpoint {
  LARGE = 'large',
  SMALL = 'small',
}

export const DEFAULT_BREAKPOINT: Breakpoint = Breakpoint.LARGE;
